import React, { useState } from 'react'
import { View } from 'react-native'
import { useDispatch } from 'react-redux'
import ActionCreators from '../../store/actions'

import * as colors from '../../config/colors'
import styles from './styles'
import { HGText, HGButton, HGGroup } from '../HGUI'
import HGModalFull from './HGModalFull'
import ForgotPasswordForm, { ForgotPaswordValues } from './ForgotPasswordForm'

type Props = {
  onAbort: () => void
  onSuccess: () => void
  navigation: any
}

const ModalForgotPassword = (props: Props) => {
  const [formSuccess, setFormSuccess] = useState(false)
  const { onAbort, onSuccess } = props
  const dispatch = useDispatch()

  const _handleFormSubmit = (
    { username: email }: ForgotPaswordValues,
    setSubmitting: Function
  ) => {
    // Validate and login user

    dispatch(ActionCreators.requestPasswordReset({ email }))
      .then((/* result */) => {
        setFormSuccess(true)
      })
      .catch((reason) => {
        dispatch(
          ActionCreators.handleError({
            code: reason.code,
            message: reason.message,
          })
        )
      })
      .then(() => {
        setSubmitting(false)
      })
  }

  return (
    <HGModalFull
      {...props}
      onRequestClose={() => {}}
      style={{ backgroundColor: colors.beige, flex: 1 }}
    >
      <HGGroup transparentMode>
        {!formSuccess && (
          <View>
            <HGText style={styles.leadHelp}>
              Bitte geben Sie die E-Mail-Adresse Ihres Accounts ein, um das
              Passwort zurückzusetzen.
            </HGText>

            <ForgotPasswordForm
              onSubmit={_handleFormSubmit}
              onAbort={onAbort}
            />
          </View>
        )}

        {formSuccess && (
          <View>
            <HGGroup>
              <HGText>
                Bitte überprüfen Sie Ihr E-Mail-Postfach und folgen Sie den
                Anweisungen in der E-Mail.
              </HGText>

              <View style={styles.actionBox}>
                <HGButton
                  title="OK"
                  style={styles.actionButton}
                  onPress={() => {
                    onSuccess()
                  }}
                />
              </View>
            </HGGroup>
          </View>
        )}
      </HGGroup>
    </HGModalFull>
  )
}

export default ModalForgotPassword
